// extracted by mini-css-extract-plugin
module.exports = {"action-btn-main":"row-image_action-btn-main__M9erY","action-btn":"row-image_action-btn__97lCD","link-btn":"row-image_link-btn___XgPE"};